/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoIcon32Regular = forwardRef('TechCamVideoIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 6a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5v-.627l4.862 3.364c1.327.918 3.138-.032 3.138-1.645V9.908c0-1.613-1.811-2.563-3.138-1.645L23 11.627V11a5 5 0 0 0-5-5H6Zm17 8.059v3.882l6 4.151V9.908l-6 4.15ZM3 11a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V11Z" })));
});
